// Copyright 2019 Sorama B.V.

import { Disposable } from "aurelia-binding";
import { IWorkflowModalConfig } from "catalogs/WorkflowModalCatalog";
import { WorkflowProperty } from "../WorkflowProperties/WorkflowPropertyObserverManager";
import { WorkflowUriModule } from "../WorkflowProperties/WorkflowPropertyUriConverter";
import { IWorkflowModuleInstance } from "./IWorkflowModule";
import { IWorkflowModuleConfig } from "./IWorkflowModuleConfig";

export abstract class IWorkflowRouter {
    /**
     *
     * @param workflowModule
     * Returns the workflow module id
     */
    public abstract addModule(
        workflowModule: WorkflowUriModule,
        position?: number,
        variant?: string
    ): Promise<IWorkflowModuleController>;

    public abstract moveModule(workflowModuleId: number, newPosition: number): void;
    public abstract closeModule(moduleId: number): void;

    public abstract getModule(moduleId: number): IWorkflowModuleController;
    public abstract getModules(workflowModule?: IWorkflowModuleConfig): IWorkflowModuleController[];
    public abstract moduleTypeExists(workflowModuleType: IWorkflowModuleConfig): boolean;
    public abstract getModulePosition(moduleId: number): number;
    public abstract scrollIntoView(moduleId: number): void;

    public abstract subscribeModulesChanged(callback: () => void): Disposable;

    public abstract readonly workflowProperties: WorkflowProperty[];

    public readonly workflowName: string;
}

export interface IWorkflowModuleController {
    isActive: boolean;
    moduleInstance: IWorkflowModuleInstance;

    /**
     * The variant of the module, will make the module look/behave differently
     */
    readonly variant: string;

    readonly config: IWorkflowModuleConfig;

    /**
     * Get the current open modalconfig. Undefined when not open.
     */
    readonly modalConfig: IWorkflowModalConfig;
    readonly moduleId: number;

    makeActive(): void;

    /**
     * Closes the referenced module.
     */
    close(): Promise<void>;
}
